import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation-comparison-form',
  templateUrl: './quotation-comparison-form.component.html',
  styleUrls: ['./quotation-comparison-form.component.css']
})
export class QuotationComparisonFormComponent implements OnInit {
  title="Quotation Comparison";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component.ts